/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last reviewed: ${i?.date}`)
};

const es_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última revisión: ${i?.date}`)
};

const de_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt überprüft: ${i?.date}`)
};

const nl_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laatst gecontroleerd: ${i?.date}`)
};

const fr_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière révision : ${i?.date}`)
};

const it_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultima revisione: ${i?.date}`)
};

const pt_br2_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última revisão: ${i?.date}`)
};

const pt_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última revisão: ${i?.date}`)
};

const ja_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最終確認日: ${i?.date}`)
};

const zh_about_last_reviewed = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最后审核日期：${i?.date}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_last_reviewed = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_last_reviewed(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_last_reviewed", locale)
	if (locale === "en") return en_about_last_reviewed(inputs)
	if (locale === "es") return es_about_last_reviewed(inputs)
	if (locale === "de") return de_about_last_reviewed(inputs)
	if (locale === "nl") return nl_about_last_reviewed(inputs)
	if (locale === "fr") return fr_about_last_reviewed(inputs)
	if (locale === "it") return it_about_last_reviewed(inputs)
	if (locale === "pt-BR") return pt_br2_about_last_reviewed(inputs)
	if (locale === "pt") return pt_about_last_reviewed(inputs)
	if (locale === "ja") return ja_about_last_reviewed(inputs)
	return zh_about_last_reviewed(inputs)
};